/** Web: FCM + service worker; no Notifee — экспорты совместимы с импортами из нативного модуля. */
export const EventType = {
  DISMISSED: 0,
  PRESS: 1,
  ACTION_PRESS: 2,
  TRIGGER_NOTIFICATION_CREATED: 3,
  DELIVERED: 4,
  SEEN: 5,
} as const;

export const AndroidImportance = {
  NONE: 0,
  MIN: 1,
  LOW: 2,
  DEFAULT: 3,
  HIGH: 4,
} as const;

/** Нужны модулю уведомлений о звонке (`notifications/callNotifications`): в вебе он не рисует ничего. */
export const AndroidCategory = { CALL: 'call', MESSAGE: 'msg' } as const;
export const AndroidVisibility = { PRIVATE: 0, PUBLIC: 1, SECRET: -1 } as const;

export const AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
} as const;

const notifee = {
  onForegroundEvent: (_cb: (ev: unknown) => void): (() => void) => () => {},
  createChannel: async (): Promise<void> => {},
  deleteChannel: async (): Promise<void> => {},
  cancelNotification: async (): Promise<void> => {},
  displayNotification: async (): Promise<void> => {},
  getDisplayedNotifications: async (): Promise<unknown[]> => [],
  getNotificationSettings: async () => ({
    authorizationStatus: AuthorizationStatus.DENIED,
  }),
  requestPermission: async (): Promise<number> => AuthorizationStatus.DENIED,
};

export default notifee;
